/* unplugin-vue-components disabled */import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/SmyFullPopup.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(__unplugin_components_0, {
    attrs: {
      "popupStyle": {
        zIndex: 150,
        background: '#fff'
      }
    },
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back back-icon",
    attrs: {
      "size": "32",
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 512 512"
    },
    on: {
      "click": function ($event) {
        _vm.isShow = false;
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })]), _c('iframe', {
    ref: "mapView",
    attrs: {
      "id": "mapView",
      "src": _vm.src
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };